import Link from 'next/link'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import { getUrlValues, getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

export const SeasonFilter = () => {
	const router = useRouter()

	const urlParts = (router.query['0'] || '').split('/')
	const group = 'gume'

	const urlPartsValues = getUrlValues({ group, urlParts })

	const urlLowest = getUrl(group, { ...urlPartsValues, sortByPrice: 'rastuce' })
	const urlHighest = getUrl(group, { ...urlPartsValues, sortByPrice: 'opadajuce' })

	console.log('SeasonFilter urlLowest', urlLowest)
	console.log('SeasonFilter urlHighest', urlHighest)

	const urlLjetnja = getUrl(group, { ...urlPartsValues, season: 'ljetnja', page: 1 })
	const urlZima = getUrl(group, { ...urlPartsValues, season: 'zimska', page: 1 })
	const urlUniverzalna = getUrl(group, { ...urlPartsValues, season: 'all-season', page: 1 })

	return (
		<div className="vehicle-parts-price-sort">
			<div className="vehicle-parts-price-sort__buttons">
				<Link as={urlLjetnja.asUrl} href={urlLjetnja.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.season === 'ljetnja' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-ljetnja.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						Ljetnja
					</a>
				</Link>
				<Link as={urlZima.asUrl} href={urlZima.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.season === 'zimska' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-zimska.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						Zimska
					</a>
				</Link>
				<Link as={urlUniverzalna.asUrl} href={urlUniverzalna.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.season === 'all-season' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-univerzalna.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						All season
					</a>
				</Link>
			</div>
		</div>
	)
}

